import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class NoteService
    extends BaseService {

    static async list(param) {
        //if (param != null) {
        //    param = { ...param };
        //    param.types = DataHelpers.convertIDList(param.types);
        //}
        return BaseService.callAPI('note/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('note/get/' + id);
    }

    static async save(note) {
        return BaseService.callAPI('note/save', note);
    }

    static async delete(id) {
        return BaseService.callAPI('note/delete/' + id);
    }
}
